import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-assessment-proctoring-screen',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './assessment-proctoring-screen.component.html',
	styleUrl: './assessment-proctoring-screen.component.scss'
})
export class AssessmentProctoringScreenComponent {

	cameraDetected = false;
	micDetected = false;
	mediaStream: MediaStream | null = null;
	internetStatus = 'Checking...';
	internetSpeed = '';


	constructor(
		private router: Router
	) { }


	checkInternetSpeed() {
		const connection =
			(navigator as any).connection ||
			(navigator as any).mozConnection ||
			(navigator as any).webkitConnection;

		if (connection) {

			const downlink = connection.downlink;
			const effectiveType = connection.effectiveType;
			this.internetSpeed = `${downlink} Mbps`;

			if (downlink >= 5) {
				this.internetStatus = 'Good';
			} else if (downlink >= 1) {
				this.internetStatus = 'Average';
			} else {
				this.internetStatus = 'Poor';
			}
		} else {
			this.internetStatus = 'Unavailable';
		}
	}



	async runSystemCheck() {
		try {

			this.mediaStream = await navigator.mediaDevices.getUserMedia({
				video: true,
				audio: true
			});

			const videoTracks = this.mediaStream.getVideoTracks();
			const audioTracks = this.mediaStream.getAudioTracks();

			this.cameraDetected = videoTracks.length > 0;
			this.micDetected = audioTracks.length > 0;

			this.checkInternetSpeed();

		} catch (error) {

			this.cameraDetected = false;
			this.micDetected = false;

			console.error(error);
		}
	}


	openAssessmentLink() {
		const url = '/my-assessment/8a63c549-a89b-4902-b3ad-3c0cc56a6737'
		this.router.navigate([url], { queryParams: { source: 'student-dashboard' } });
	}


}
